<template>
	<b-container>
    <p>{{ $t("presentation")}}</p>

    <div style="min-height: 300px" class="d-flex justify-content-center align-items-center">
    <b-card v-if="currentSlide != null" class="text-center">
      <b-card-title>{{ currentSlide.caption }}</b-card-title>
      <b-card-text>
        <div v-if="currentSlide.text" class="mb-2">{{ currentSlide.text }}</div>
        <div class="d-flex flex-column justify-content-center align-items-center">
          <a v-if="imageSrc && linkHref" :href="linkHref" target="_blank" rel="noopener">
            <b-img :src="imageSrc" fluid alt="slide image" class="mb-2 slide-image clickable-image"/>
          </a>
          <b-img v-else-if="imageSrc" :src="imageSrc" fluid alt="slide image" class="mb-2 slide-image"/>
          <b-button v-if="linkHref" :href="linkHref" target="_blank" rel="noopener" variant="primary">
            {{ $t('visit') || 'Visiter' }}
          </b-button>
        </div>
      </b-card-text>
    </b-card>
    <b-container  v-else class="d-flex justify-content-center align-items-center">
      <b-spinner/>
    </b-container>
    </div>

    <!-- Slide controls and indicators -->
    <div v-if="loadedSlides && loadedSlides.length" class="d-flex justify-content-center align-items-center mt-2">
      <b-button size="sm" variant="outline-primary" @click="showPrevSlide" :disabled="loadedSlides.length < 2">‹</b-button>
      <div class="mx-3"><small>{{ indicatorText }}</small></div>
      <b-button size="sm" variant="outline-primary" @click="showNextSlide" :disabled="loadedSlides.length < 2">›</b-button>
    </div>
    <div v-if="loadedSlides && loadedSlides.length > 1" class="d-flex justify-content-center mt-2">
      <span v-for="(s, idx) in loadedSlides" :key="s.key || idx" class="indicator-dot" :class="{active: idx === currentSlideIndex}"
            @click="goToSlide(idx)"></span>
    </div>

<!--    <b-carousel-->
<!--        id="accueil"-->
<!--        v-model="slide"-->
<!--        :interval="8000"-->
<!--        controls-->
<!--        img-height="100"-->
<!--        img-width="250"-->
<!--        indicators-->
<!--        background="#ababab"-->
<!--        @sliding-start="onSlideStart"-->
<!--        @sliding-end="onSlideEnd"-->
<!--        v-if="mounted"-->
<!--    >-->
<!--      <div v-for="i in loadedSlides" :key="i.key">-->
<!--&lt;!&ndash;        :img-src="`${urlBase}${i.img_src}`"&ndash;&gt;-->
<!--        <b-carousel-slide-->
<!--                          :caption="i.caption"-->
<!--                          :text="i.text"-->
<!--                          img-blank-color="blue"-->
<!--                          img-alt="Blank image"-->

<!--        >-->
<!--          <p>-->
<!--          <a :href="`${urlBase}${i.img_src}`">{{urlBase+i.img_src}}</a>-->
<!--          </p>-->
<!--        </b-carousel-slide>-->
<!--      </div>-->
<!--    </b-carousel>-->
<!--    <b-img v-for="i in slides" :key="i.key" :src="i.img_src"/>-->

    <b-card>
      <b-card-title>{{ $t("Publications")  }}</b-card-title>
      <b-card-body>
        <BibRendering/>
      </b-card-body>
    </b-card>

    <div class="my-3">
    <b-button v-b-toggle.collapse-discours-de-la-methode >
      {{ $t("voir_plus_sur_descartes") }}
    </b-button>
    <b-collapse id="collapse-discours-de-la-methode">
      <div>
          <p v-html="$t('presentation_quatre_regles_descartes')"></p>
      </div>
      <div class="text-justify">
          <blockquote>
              <p>« Le premier eſtoit de ne receuoir iamais aucune choſe pour vraye, que ie ne la connuſſe euidemment eſtre telle : c’eſt a dire, d’euiter ſoigneuſement la Precipitation, & la Preuention ; & de ne comprendre rien de plus en mes iugemens, que ce qui ſe preſenteroit ſi clairement & ſi diſtindement a mon eſprit, que ie n’euſſe aucune occaſion de le mettre en doute.</p>
              <p>Le ſecond, de diuiſer chaſcune des difficultez que i’examinerois, en autant de parcelles qu’il ſe pourroit, & qu’il ſeroit requis pour les mieux reſoudre.</p>
              <p>Le troiſieſme, de conduire par ordre mes penſées, en commençant par les obiets les plus ſimples & les plus ayſez a connoiſtre, pour monter peu a peu, comme par degrez, iuſques a la connoiſſance des plus compoſez ; et ſuppoſant meſme de l’ordre entre ceux qui ne ſe precedent point naturellement les vns les autres.</p>
              <p>Et le dernier, de faire partout des denombremens ſi entiers, & des reueuës ſi generales, que ie fuſſe aſſuré de ne rien omettre. »</p>
          </blockquote>
      </div>

      <div>
          <p>{{ $t("presentation_morale_provisoire") }}</p>
      </div>

      <div class="text-justify" >
          <blockquote>
              <p>« La premiere eſtoit d’obeir aux lois & aux couſtumes de mon païs, retenant conſtanment la religion en laquelle Dieu m’a fait la grace d’eſtre inſtruit dés mon enfance, & me gouuernant, en toute autre choſe, ſuiuant les opinions les plus moderées, & les plus eſloignées de l’excés, qui fuſſent communement receuës en pratique par les mieux ſenſez de ceux auec leſquels i’aurois a viure. [...]</p>
              <p>Ma ſeconde maxime eſtoit d’eſtre le plus ferme & le plus reſolu en mes actions que ie pourrois, & de ne ſuiure pas moins conſtanment les opinions les plus douteuſes, lorſque ie m’y ſerois vne fois determiné, que ſi elles euſſent eſté tres aſſurées. [...]</p>
              <p>Ma troiſieſme maxime eſtoit de taſcher touſiours plutoſt a me vaincre que la fortune, & a changer mes deſirs que l’ordre du monde ; et generalement, de m’accouſtumer a croire qu’il n’y a rien qui ſoit entierement en noſtre pouuoir, que nos penſées, en ſorte qu’aprés que nous auons fait noſtre mieux, touchant les choſes qui nous ſont exterieures, tout ce qui manque de nous reuſſir eſt, au regard de nous, abſolument impoſſible. [...]</p>
              <p>Enfin, pour concluſion de cete Morale, ie m’auiſay de faire vne reueuë ſur les diuerſes occupations qu’ont les hommes en cete vie, pour taſcher a faire chois de la meilleure ; & ſans que ie vueille rien dire de celles des autres, ie penſay que ie ne pouuois mieux que de continuër en celle la meſme ou ie me trouuois, c’eſt a dire, que d’employer toute ma vie a cultiuer ma raiſon, & m’auancer, autant que ie pourrois, en la connoiſſance de la verité, ſuiuant la Methode que ie m’eſtois preſcrite. I’auois eſprouué de ſi extremes contentemens, depuis que i’auois commencé a me ſeruir de cete Methode, que ie ne croyois pas qu’on en puſt receuoir de plus doux, ny de plus innocens, en cete vie ; et deſcouurant tous les iours par ſon moyen quelques veritez, qui me ſembloient aſſez importantes, & communement ignorées des autres hommes, la ſatisfaction que i’en auois rempliſſoit tellement mon eſprit que tout le reſte ne me touchoit point. »</p>
          </blockquote>
      </div>

      <a href="https://fr.wikisource.org/wiki/Discours_de_la_m%C3%A9thode/%C3%89dition_Adam_et_Tannery"><strong>Discours de la méthode édition</strong> d'Adam et Tannery</a>
    </b-collapse>

    </div>
	</b-container>

</template>

<script>
import BibRendering from "@/components/BibRendering";
import {getSlides} from "@/api";
export default {
  name: "WelcomePage",
  components: {BibRendering},
  data: function() {
    return {
      currentSlideIndex: 0,
      sliding: null,
      currentSlide: null,
      loadedSlides: [],
      urlBase: "http://localhost:5001",
      slideTimerId: null,
    }
  },
  computed: {
    imageSrc() {
      if (!this.currentSlide || !this.currentSlide.img_src) return null;
      // If the img_src is an absolute URL, use it directly; otherwise prefix with base URL
      const src = this.currentSlide.img_src;
      if (/^https?:\/\//i.test(src)) return src;
      return `${this.urlBase}${src}`;
    },
    linkHref() {
      if (!this.currentSlide) return null;
      let l = this.currentSlide.link;
      // If there's no explicit link, but text looks like a URL, use it
      if (!l && typeof this.currentSlide.text === 'string' && /^https?:\/\//i.test(this.currentSlide.text.trim())) {
        l = this.currentSlide.text.trim();
      }
      if (!l) return null;
      return /^https?:\/\//i.test(l) ? l : `${this.urlBase}${l}`;
    },
    totalSlides() {
      return this.loadedSlides ? this.loadedSlides.length : 0;
    },
    indicatorText() {
      if (!this.totalSlides) return '';
      return `${this.currentSlideIndex + 1} / ${this.totalSlides}`;
    }
  },
  methods: {
    onSlideStart() {
        this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    loadSlides() {
      return getSlides(this.$i18n.locale).then((response) => {
        this.loadedSlides = response.data.slides || [];
        if (this.loadedSlides.length > 0) {
          this.currentSlideIndex = 0;
          this.currentSlide = this.loadedSlides[0];
          if (!this.slideTimerId) {
            this.slideTimerId = setInterval(this.showNextSlide, 5000);
          }
        }
      });
    },
    showNextSlide() {
      if (!this.loadedSlides || this.loadedSlides.length === 0) return;
      if(this.currentSlideIndex < this.loadedSlides.length - 1) {
        this.currentSlideIndex ++;
      } else {
        this.currentSlideIndex = 0;
      }
      this.currentSlide = this.loadedSlides[this.currentSlideIndex];
    },
    showPrevSlide() {
      if (!this.loadedSlides || this.loadedSlides.length === 0) return;
      if (this.currentSlideIndex > 0) {
        this.currentSlideIndex--;
      } else {
        this.currentSlideIndex = this.loadedSlides.length - 1;
      }
      this.currentSlide = this.loadedSlides[this.currentSlideIndex];
    },
    goToSlide(index) {
      if (!this.loadedSlides || this.loadedSlides.length === 0) return;
      if (index >= 0 && index < this.loadedSlides.length) {
        this.currentSlideIndex = index;
        this.currentSlide = this.loadedSlides[index];
      }
    }

  },
  watch: {
    '$i18n.locale'() {
      if (this.slideTimerId) {
        clearInterval(this.slideTimerId);
        this.slideTimerId = null;
      }
      this.currentSlide = null;
      this.currentSlideIndex = 0;
      this.loadedSlides = [];
      this.loadSlides();
    }
  },
  mounted() {
    // Prefer environment variable if defined, else fallback to window origin already set in data
    if (typeof process !== 'undefined' && process.env && process.env.VUE_APP_SITE_API_URL) {
      this.urlBase = process.env.VUE_APP_SITE_API_URL;
    }
    this.loadSlides();
  },
  beforeDestroy() {
    if (this.slideTimerId) {
      clearInterval(this.slideTimerId);
      this.slideTimerId = null;
    }
  }
}
</script>

<style scoped>


.carousel-item {
  height: 300px;
}

.slide-image {
  max-height: 150px;
  width: auto;
}

.indicator-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #cfd8dc;
  margin: 0 4px;
  cursor: pointer;
  display: inline-block;
}
.indicator-dot.active {
  background-color: #007bff;
}

</style>


.clickable-image {
  cursor: pointer;
}
